/**
 * @module Services/Bff/Presenters/Response/Cart
 * @desc Cart Presenter
 *
 */

import { formatMoney, upperCaseToLowerCase } from 'core/utilities';

import type { CartResponse, RewardProcessResponse } from '../../@types';
import type { PriceProcessed } from 'core/domains/cart';

/**
 * Transforms the cart response data model into the rewards domain model
 *
 */

export function rewardPresenter({
  data,
  success,
}: CartResponse): RewardProcessResponse['rewards']['data'] {
  const { rewards } = data;
  const { price } = data as unknown as { price: PriceProcessed };
  const {
    reseller: { deliveryModes },
  } = data;
  if (!rewards) {
    return {} as RewardProcessResponse['rewards']['data'];
  }

  const { discounts = [], gifts = [], choose = [] } = rewards;

  return {
    success,
    order: {
      code: data.id,
    },
    price,
    availableItems: data.availableItems,
    discounts: discounts.flatMap(({ promotion }) => promotion),
    gifts: gifts.flatMap(({ items = [] }) =>
      items.map((item) => ({
        image: item.images.find(({ imageSize }) => imageSize === 'medium') || {},
        name: upperCaseToLowerCase(item.name),
        priceTotal: item.productPriceSpecification.resellerPrice
          ? formatMoney(item.productPriceSpecification.resellerPrice)
          : 'Grátis',
        productCode: item.sku.toString(),
        quantity: item.quantity,
      })),
    ),
    choose,
    shippingModel: deliveryModes[0],
  } as RewardProcessResponse['rewards']['data'];
}
